@if (allTasks) {
    <div class="results-table">
    <table
            mat-table
            [dataSource]="allTasks"
            multiTemplateDataRows
            class="mat-elevation-z8"
            [trackBy]="trackByTask"
    >
        <!-- Task ID Column -->
        <ng-container matColumnDef="id">
            <th *matHeaderCellDef mat-header-cell> Task ID</th>
            <td *matCellDef="let task" mat-cell> {{ task.id }}</td>
        </ng-container>
        <!-- Client ID Column -->
        <ng-container matColumnDef="clientId">
            <th *matHeaderCellDef mat-header-cell> Client ID</th>
            <td *matCellDef="let task" mat-cell> {{ task.clientId }}</td>
        </ng-container>
        <!-- Description Column -->
        <ng-container matColumnDef="description">
            <th *matHeaderCellDef mat-header-cell> Description</th>
            <td *matCellDef="let task" mat-cell> {{ task.description }}</td>
        </ng-container>
        <!-- Created Column -->
        <ng-container matColumnDef="created">
            <th *matHeaderCellDef mat-header-cell> Created</th>
            <td *matCellDef="let task" mat-cell> {{ task.created | date: 'short' }}</td>
        </ng-container>
        <!-- Completed Successfully Column -->
        <ng-container matColumnDef="completedSuccessfully">
            <th *matHeaderCellDef mat-header-cell> Completed?</th>
            <td mat-cell *matCellDef="let task">
                {{ task.completedSuccessfully ? 'Yes' : 'No' }}
            </td>
        </ng-container>
        <!-- Expanded Detail Column -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let task" [attr.colspan]="displayedColumns.length">
                <div class="detail-container">
                    <!-- Basic Info -->
                    <div class="detail-section">
                        <h4>Task Details</h4>
                        <p><strong>Task Type:</strong> {{ task.taskType }}</p>
                        <p><strong>Client ID:</strong> {{ task.clientId }}</p>
                        <p><strong>Description:</strong> {{ task.description }}</p>
                        <p><strong>Created:</strong> {{ task.created | date: 'medium' }}</p>
                        <p>
                            <strong>Completed Successfully:</strong>
                            {{ task.completedSuccessfully ? 'Yes' : 'No' }}
                        </p>
                        <p><strong>Attempts:</strong> {{ task.attempts }}</p>
                        @if (task.lastAttempt) {
                            <p>
                                <strong>Last Attempt:</strong> {{ task.lastAttempt | date: 'medium' }}
                            </p>
                        }
                        @if (task.completed) {
                            <p>
                                <strong>Completed:</strong> {{ task.completed | date: 'medium' }}
                            </p>
                        }
                    </div>
                    <!-- Execution & Notifications -->
                    <div class="detail-section">
                        <p>
                            <strong>Email Notifications Enabled:</strong>
                            {{ task.emailNotificationsEnabled ? 'Yes' : 'No' }}
                        </p>
                        @if (task.emailNotificationsEnabled) {
                            <p>
                                <strong>Subject:</strong> {{ task.emailNotificationSubject }}
                            </p>
                        }
                        @if (task.emailNotificationsEnabled && task.emailNotificationRecipients?.length) {
                            <p>
                                <strong>Recipients:</strong> {{ task.emailNotificationRecipients.join(', ') }}
                            </p>
                        }
                    </div>
                    <!-- Additional Data -->
                    <div class="detail-section">
                        <h4>Additional Data</h4>
                        <div [innerHTML]="marked.parse(task.data)"></div>
                        @if (task.updateMessages?.length) {
                            <div>
                                <strong>Update Messages:</strong>
                                <ul>
                                    @for (msg of task.updateMessages; track msg) {
                                        <li> {{ msg }}</li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                    <!-- Completion IDs & Execution Results -->
                    <div class="detail-section">
                        <h4>Completion IDs</h4>
                        <p><strong>Originating:</strong> {{ task.originatingCompletionId }}</p>
                        <p><strong>Executing:</strong> {{ task.executingCompletionId }}</p>
                        <h4>Execution & Notifications</h4>
                        @if (task.taskExecutionResult) {
                            <div>
                                @for (output of task.taskExecutionResult.outputs; track output) {
                                    @if (parseJsonOutput(output); as parsedOutput) {
                                        <button (click)="downloadExcel(parsedOutput)" color="primary" mat-raised-button>
                                            Download Excel
                                        </button>
                                        <div class="results-table">
                                            <table [dataSource]="parsedOutput" class="mat-elevation-z8" mat-table>
                                                <!-- URL Column -->
                                                <ng-container matColumnDef="url">
                                                    <th *matHeaderCellDef mat-header-cell> URL</th>
                                                    <td *matCellDef="let element" mat-cell> {{ element.Url }}</td>
                                                </ng-container>
                                                <!-- Dynamic Step Columns -->
                                                @for (step of parsedOutput[0]?.Steps; track step; let i = $index) {
                                                    <ng-container
                                                            [matColumnDef]="getStepColumnName(parsedOutput, i)"
                                                    >
                                                        <th *matHeaderCellDef mat-header-cell>
                                                            {{ getStepName(parsedOutput, i) }}
                                                        </th>
                                                        <td *matCellDef="let element" mat-cell>
                                                            {{ element.Steps[i]?.Result[getStepName(parsedOutput, i)] }}
                                                        </td>
                                                    </ng-container>
                                                }
                                                <tr
                                                        *matHeaderRowDef="getStepColumns(parsedOutput)"
                                                        mat-header-row
                                                ></tr>
                                                <tr
                                                        *matRowDef="let row; columns: getStepColumns(parsedOutput)"
                                                        mat-row
                                                ></tr>
                                            </table>
                                        </div>
                                    }
                                }
                            </div>
                        }
                    </div>
                </div>
            </td>
        </ng-container>
        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- Data Row -->
        <tr
                mat-row
                *matRowDef="let task; columns: displayedColumns"
                class="element-row"
                (click)="detailRow(task)"
        ></tr>
        <!-- Detail Row -->
        <tr
                mat-row
                *matRowDef="let task; columns: ['expandedDetail']"
                class="detail-row"
                [style.display]="expandedElement === task ? 'table-row' : 'none'"
        ></tr>
    </table>
    </div>
}